/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AiOfferDraftItemUpdateRequest model module.
 * @module model/AiOfferDraftItemUpdateRequest
 * @version 1.0.0
 */
class AiOfferDraftItemUpdateRequest {
    /**
     * Constructs a new <code>AiOfferDraftItemUpdateRequest</code>.
     * @alias module:model/AiOfferDraftItemUpdateRequest
     */
    constructor() { 
        
        AiOfferDraftItemUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AiOfferDraftItemUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferDraftItemUpdateRequest} obj Optional instance to populate.
     * @return {module:model/AiOfferDraftItemUpdateRequest} The populated <code>AiOfferDraftItemUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferDraftItemUpdateRequest();

            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('proposal_content')) {
                obj['proposal_content'] = ApiClient.convertToType(data['proposal_content'], 'String');
            }
            if (data.hasOwnProperty('confirmed')) {
                obj['confirmed'] = ApiClient.convertToType(data['confirmed'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferDraftItemUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferDraftItemUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }
        // ensure the json data is a string
        if (data['proposal_content'] && !(typeof data['proposal_content'] === 'string' || data['proposal_content'] instanceof String)) {
            throw new Error("Expected the field `proposal_content` to be a primitive type in the JSON string but got " + data['proposal_content']);
        }

        return true;
    }


}



/**
 * @member {String} short_appeal_message
 */
AiOfferDraftItemUpdateRequest.prototype['short_appeal_message'] = undefined;

/**
 * @member {String} proposal_content
 */
AiOfferDraftItemUpdateRequest.prototype['proposal_content'] = undefined;

/**
 * @member {Boolean} confirmed
 */
AiOfferDraftItemUpdateRequest.prototype['confirmed'] = undefined;






export default AiOfferDraftItemUpdateRequest;

